import { ACCESS_TOKEN, REFRESH_TOKEN } from "../constants";
import { API_BASE_URL, ENDPOINTS } from "../config";

export const ensureValidAccessToken = async (): Promise<boolean> => {
  const accessToken = localStorage.getItem(ACCESS_TOKEN);

  if (accessToken) {
    try {
      const payload = JSON.parse(atob(accessToken.split(".")[1]));
      if (payload.exp > Date.now() / 1000) return true;
    } catch {
      // token not decodable — fall through to refresh
    }
  }

  const refreshToken = localStorage.getItem(REFRESH_TOKEN);
  if (!refreshToken) return false;

  try {
    const response = await fetch(`${API_BASE_URL}${ENDPOINTS.refresh}`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ refresh: refreshToken }),
    });

    if (!response.ok) return false;

    const data = await response.json();
    const newAccess = data?.access ?? data?.access_token ?? null;

    if (newAccess) {
      localStorage.setItem(ACCESS_TOKEN, newAccess);
      const newRefresh = data?.refresh ?? data?.refresh_token;
      if (newRefresh) localStorage.setItem(REFRESH_TOKEN, newRefresh);
      return true;
    }

    return false;
  } catch (error) {
    console.error("[tokenManager] Token refresh failed:", error);
    return false;
  }
};
